import { render, staticRenderFns } from "./XingbieNianlin.vue?vue&type=template&id=2cbe9c6d&"
import script from "./XingbieNianlin.vue?vue&type=script&lang=js&"
export * from "./XingbieNianlin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports